/***
 * @file:ç©ºå¿ç¶æè²åè½¬æ¢ç®¡é
 * @author: linkun.he
 * @Date: 2019-06-05 14:07:23
 * label: è¦æ¾ç¤ºçå­æ®µ
 * matchLableï¼
 *
 *  {
 *    type: 'hollowColorLump',  //ç±»å
 *    label: 'stateDesc', // æ ¹æ®æ­¤é®åå¼æ¾ç¤º
 *    matchLable: "state", // æ ¹æ®å¶å¹écodeç  å³å®ç¨ä»ä¹é¢è²
 *    value: 'ç¶æ', // è¡¨å¤´å­
 *    class: 'tc',
 *      config: [
 *        { code: '01', color: '#e64340' }, // ä¸åcodeç å¯¹åºä¸åçé¢è²ï¼å¹¶æ¸²æ
 *        { code: '02', color: '#09bb07' },
 *        { code: '03', color: '#4dcccb' },
 *        { code: '04', color: '#c9c9c9' },
 *      ],
 *   },
 * */
import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';
import { HollowColorLump, LumpRenderConf } from './hollow-color-lump.interface';

@Pipe({
  name: 'hollowColorLump',
})
export class HollowColorLumpPipe implements PipeTransform {
  transform(data: object, column: HollowColorLump): any {
    const { label, matchLable, config } = column;
    const lumpData: LumpRenderConf = config.filter((conf) => conf.code === data[matchLable])[0];
    lumpData.name = data[label];
    if (!isEmpty(lumpData)) {
      return creatLump(lumpData);
    } else {
      return '';
    }
  }
}

function creatLump(data: LumpRenderConf) {
  return `<span class="color-lump" style="background: #fff; color:${data.color}; border: 1px  ${data.color} solid;border-radius: 14px;">${data.name}<span>`;
}
